'use client';

import { Suspense } from 'react';
import ContentLoader from 'react-content-loader';
import { twMerge } from 'tailwind-merge';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { IInternalLinkProps } from '../../../../Clickables/NonCrawlableLink/NonCrawlableLink';
import { LoginButton } from './LoginButton';

const LoginButtonFallback = ({ className, id }: { className?: string; id: string }) => {
  return (
    <div className="size-full" aria-label="log in to Fishbrain">
      {/* Log in */}
      <ContentLoader
        uniqueKey={`${id}-loader`}
        aria-label="Loading login button"
        className={twMerge('flex h-[35px] w-[81px]', className)}
        speed={2}
      >
        <rect x="0" y="0" width="100%" height="100%" />
      </ContentLoader>
    </div>
  );
};

export const SuspendedLoginButton = ({
  buttonSize = 'default',
  className,
  fallbackClassName,
  id,
}: {
  buttonSize?: IInternalLinkProps['size'];
  className?: string;
  fallbackClassName?: string;
  id: string;
}) => {
  const { currentPage } = useAnalytics();
  return (
    <Suspense fallback={<LoginButtonFallback className={fallbackClassName} id={id} />}>
      <LoginButton
        buttonSize={buttonSize}
        className={className}
        testId={id}
        onClick={() => {
          trackEvent({
            name: 'mykiss_hamburger_clicked',
            properties: { action: 'navigate', source: currentPage },
          });
        }}
      />
    </Suspense>
  );
};
